import { useQuery } from '@tanstack/react-query';
import { fetchCategoriesByTarget } from '../api/categoriesApi';

// Mirrors server-side ScanTargetType.
export const CATEGORY_TARGET = Object.freeze({
    Expense: 0,
    Invoice: 1,
});

// Per-company category list for (CompanyId, targetType). The list is seeded
// once per company (see TenantMiddleware / migration backfill) and isn't
// edited by the app, so a long stale time is fine — we just want to avoid
// re-fetching it every modal open within a session.
export default function useCategories(targetType) {
    return useQuery({
        queryKey: ['categories', targetType],
        queryFn: () => fetchCategoriesByTarget(targetType),
        staleTime: 60 * 60 * 1000, // 1h — categories effectively don't change
        enabled: targetType === CATEGORY_TARGET.Expense
              || targetType === CATEGORY_TARGET.Invoice,
    });
}
